import { type Context } from '@atlassian/post-office-context';

const GRAPHQL_ENDPOINT = '/gateway/api/graphql';

type DismissAppRecommendationData = {
	appRecommendations: {
		dismissRecommendation: {
			success: boolean;
			error?: Error;
		};
	};
};

type DismissAppRecommendationResponse = {
	data: DismissAppRecommendationData;
};

const dismissAppMutation = `
                mutation DismissRecommendation($args: AppRecDismissRecommendationInput!){
                  appRecommendations {
                    dismissRecommendation(input:$args){
                      success
                      errors{
                        message
                      }
                    }
                  }
                }
                `;

export const dismissApp = async (productId: string, context: Context): Promise<boolean> => {
	try {
		const headers = new Headers();
		headers.append('Content-Type', 'application/json');
		const request = new Request(GRAPHQL_ENDPOINT, {
			method: 'POST',
			credentials: 'include',
			mode: 'cors',
			headers,
			body: JSON.stringify({
				query: dismissAppMutation,
				variables: {
					args: {
						productId,
						context,
					},
				},
			}),
		});

		const response = (await (
			await fetch(request)
		).json()) as unknown as DismissAppRecommendationResponse;
		return response.data.appRecommendations.dismissRecommendation.success;
	} catch (error) {
		return false;
	}
};
